import { useRoutes } from 'react-router-dom';
import { BreadcrumbsRoute } from 'use-react-router-breadcrumbs';

import { AppController } from '../../controllers';
import { useState } from 'react';

export const useAppRouter = (): {
  router: {
    common: ReturnType<typeof useRoutes>;
    drawer: ReturnType<typeof useRoutes>;
  };
  routes: {
    common: BreadcrumbsRoute[];
    drawer: BreadcrumbsRoute[];
  };
} => {
  const [commonRoutes] = useState(() => AppController.common);
  const [drawerRoutes] = useState(() => AppController.drawer);

  const CommonRouter = useRoutes(commonRoutes);
  const DrawerRouter = useRoutes(drawerRoutes);

  return {
    router: {
      common: CommonRouter,
      drawer: DrawerRouter
    },
    routes: {
      common: commonRoutes,
      drawer: drawerRoutes
    }
  };
};
